import { RemoteGatewayAuthenticationType, RemoteGatewayObject, RemoteGatewayType } from "./RemoteGateway";

export interface SellerDefaultGateway {
    id?: ID;
    object?: RemoteGatewayObject;
    publicKey: string;
    type?: RemoteGatewayType;
    authenticationType?: RemoteGatewayAuthenticationType;
    credentials?: { apiLoginId: string; transactionKey: string };
}

export enum PaymentGatewayErrors {
    OPEN_ADDITIONAL_INFO_MODAL = "additional_info_required_payment_failed",
}
